export default __webpack_public_path__ + "static/media/5.13.bc423211.mp3";